import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedPingPongModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Ping Pong (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-pingpong"
      icon="solar:ping-pong-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Control your paddle by moving the mouse to hit the ball back to the computer's side.",
        "Score points by making the computer miss the ball."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedPingPongModal;
